/**
 * Loading shell shown while MarketView suspends. Mirrors the market layout
 * (header + search + grid) so the Suspense fallback matches the page skeleton
 * instead of a bare "Loading…" (Phase 2).
 */
export default function MarketViewSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header placeholder */}
        <div className="mb-6 animate-pulse">
          <div className="h-8 w-64 max-w-full bg-tertiary rounded mb-2" />
          <div className="h-4 w-40 bg-tertiary rounded" />
        </div>

        {/* Search bar placeholder */}
        <div className="sio-glass rounded-sio-lg p-4 mb-6 animate-pulse">
          <div className="h-10 w-full bg-tertiary rounded" />
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          {/* Sidebar placeholder — desktop from lg (matches MarketView) */}
          <div className="hidden lg:block w-full lg:w-64 flex-shrink-0">
            <div className="sio-surface-card p-4 space-y-4 animate-pulse">
              <div className="h-4 w-24 bg-tertiary rounded" />
              <div className="h-10 w-full bg-tertiary rounded" />
              <div className="h-10 w-full bg-tertiary rounded" />
            </div>
          </div>

          {/* Grid placeholder — min-w-0 matches MarketView main column */}
          <div className="min-w-0 flex-1">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="animate-pulse">
                  <div className="bg-tertiary rounded-lg h-48 mb-4" />
                  <div className="h-4 bg-tertiary rounded w-3/4 mb-2" />
                  <div className="h-4 bg-tertiary rounded w-1/2" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
